import React from 'react'
import {Box, themeGet, AtlasTooltip, Tooltip, AtlasTooltipProps} from '../..'
import {Placement} from '../../components/Tooltip'
export interface IconWithTooltipProps extends AtlasTooltipProps {
  /**
   * The icon that should be described by the Tooltip
   */
  children?: React.ReactNode
  /**
   * Whether the tooltip should display an arrow
   */
  hideArrow?: boolean
  /**
   *  Where the tooltip should appear relative to its target.
   */
  position?: Placement
}

const IconWithTooltip = ({
  children,
  content,
  position = 'bottom',
  hideArrow = true,
  ...props
}: IconWithTooltipProps) => {
  return (
    <Tooltip.Provider>
      <AtlasTooltip delay={0} hideArrow={hideArrow} content={content} position={position}>
        <Box sx={{width: 'fit-content'}}>{children}</Box>
      </AtlasTooltip>
    </Tooltip.Provider>
  )
}
export default IconWithTooltip
